// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__mainBox--aETY4 {
  display: flex;
  height: 100%;
  overflow: hidden;
  position: relative;
}
.src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__loader--LZHza {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.75);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
}
.src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__splitter--zC5y5 {
  background-color: #f0f0f0;
  display: flex;
  padding: 0 2px;
  justify-content: center;
  align-items: center;
  cursor: col-resize;
}
.src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__splitter--zC5y5 .src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__center--n0Pa7 {
  background-color: #bfbfbf;
  height: 56px;
  width: 4px;
  border-radius: 4px;
}
.src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__part--rRVrr {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__table--DJP_d {
  flex: 1;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__foot--ISbvP {
  height: 32px;
}
.src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__head--aY5JQ {
  height: 48px;
  min-height: 48px;
  max-height: 48px;
  overflow: hidden;
  background-color: #fafafa;
  border-top: thin solid rgba(0, 0, 0, 0.06);
  border-bottom: thin solid rgba(0, 0, 0, 0.06);
}
.src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__body--BChGj {
  overflow: hidden;
}
.src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__bodyBox--nOuuF {
  flex: 1;
  overflow-y: auto;
  overflow-x: scroll;
  position: relative;
}
.src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__leftPart--zgatE {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-width: 20%;
  max-width: 90%;
}
.src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__leftPart--zgatE.src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__singleLeftPart--nxn6Q {
  max-width: 100%;
}
.src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__leftPart--zgatE.src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__singleLeftPart--nxn6Q .src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__leftTable--SJSL9 {
  overflow-x: auto;
}
.src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__leftTable--SJSL9 {
  flex: 1;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__leftEmpty--VSQR9 {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 48px;
}
.src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__leftFoot--yAupx {
  height: 32px;
}
.src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__leftHead--DBfEf {
  height: 48px;
  min-height: 48px;
  max-height: 48px;
  overflow: hidden;
  background-color: #fafafa;
  border-top: thin solid rgba(0, 0, 0, 0.06);
  border-bottom: thin solid rgba(0, 0, 0, 0.06);
  display: grid;
}
.src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__leftHead--DBfEf .src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__th--lifFD {
  border-right: thin solid rgba(0, 0, 0, 0.06);
}
.src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__leftBody--JuF0I {
  overflow: hidden;
  width: max-content;
  display: grid;
  grid-auto-rows: minmax(38px, 38px);
  overflow: visible;
}
.src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__leftBody--JuF0I .src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__td--WOgoS {
  padding: 0 8px;
  display: flex;
  align-items: center;
  border-bottom: thin solid rgba(0, 0, 0, 0.06);
  border-right: thin solid transparent;
}
.src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__leftBody--JuF0I .src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__td--WOgoS > span {
  overflow: hidden;
  color: rgba(0, 0, 0, 0.85);
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  font-weight: 400;
  line-height: 160%;
}
.src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__fixedCell--rnRJk {
  position: sticky;
  z-index: 1;
  background-color: #fff;
}
.src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__fixedOverlap--BLfOo {
  box-shadow: 10px 0 8px -8px rgba(5, 5, 5, 0.1);
}
.src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__fixedLastCell--b3yDe {
  border-right: thin solid rgba(0, 0, 0, 0.06) !important;
}
.src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__rightPart--YD3qP {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  flex: 1;
}
.src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__rightTable--dexv6 {
  flex: 1;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__rightFoot--AlI_z {
  height: 32px;
}
.src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__rightHead--I4u1H {
  height: 48px;
  min-height: 48px;
  max-height: 48px;
  background-color: #fafafa;
  border-top: thin solid rgba(0, 0, 0, 0.06);
  border-bottom: thin solid rgba(0, 0, 0, 0.06);
  overflow: hidden;
}
.src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__rightBody--Y3rwx {
  overflow: hidden;
  overflow-y: auto;
  overflow-x: scroll;
  flex: 1;
}
.src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__prognosisBar--xexNx {
  background-color: #adc6ff;
}
.src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__factBar--kR0wi {
  background-color: #1a8a94;
}
.src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__planBar--SVamG {
  background-color: #83a3af;
}
.src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__delayBar--GWu_G {
  background-color: #c20034;
}
.src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__workBar--y50CH {
  background-color: #e0a23c;
}
.src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__ganttToolBox--XM_Eu {
  height: 100%;
  overflow: visible;
}
.src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__ganttTools--lYDWm {
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: flex-end;
  height: 100%;
  padding: 0 9px;
  color: rgba(0, 0, 0, 0.55);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}
.src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__legendBar--AYLCG {
  width: 10px;
  height: 10px;
}
.src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__legendItem--X5kdY {
  display: flex;
  align-items: center;
  gap: 4px;
}
.src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__scaleBox--MXsfq {
  min-width: 100px;
  max-width: 100px;
  flex: 1;
}
`, "",{"version":3,"sources":["webpack://./src/businessServices/services/bsPlanning2/Planning2Control/Planning2Gantt/Planning2Gantt.module.less"],"names":[],"mappings":"AAqCA;EACE,aAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;AApCF;AAuCA;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,2CAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;AArCF;AAwCA;EACE,yBAAA;EACA,aAAA;EACA,cAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAtCF;AAgCA;EAQI,yBAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;AArCJ;AAyCA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;AAvCF;AAyCA;EACE,OAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AAvCF;AAyCA;EACE,YAAA;AAvCF;AAyCA;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,0CAAA;EACA,6CAAA;AAvCF;AAyCA;EACE,gBAAA;AAvCF;AAyCA;EACE,OAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AAvCF;AA4CA;EAnCE,aAAA;EACA,sBAAA;EACA,gBAAA;EAmCA,cAAA;EACA,cAAA;AAxCF;AA0CE;EACE,eAAA;AAxCJ;AAuCE;EAGI,gBAAA;AAvCN;AA4CA;EA3CE,OAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AAEF;AAyCA;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AAvCF;AA0CA;EApDE,YAAA;AAaF;AA2CA;EArDE,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,0CAAA;EACA,6CAAA;EAiDA,aAAA;AAnCF;AAiCA;EAKI,4CAAA;AAnCJ;AAuCA;EArDE,gBAAA;EAuDA,kBAAA;EACA,aAAA;EACA,kCAAA;EACA,iBAAA;AArCF;AAgCA;EAQI,cAAA;EACA,aAAA;EACA,mBAAA;EACA,6CAAA;EACA,oCAAA;AArCJ;AAuCI;EACE,gBAAA;EACA,0BAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AArCN;AA0CA;EACE,gBAAA;EACA,UAAA;EACA,sBAAA;AAxCF;AA0CA;EACE,8CAAA;AAxCF;AA0CA;EACE,uDAAA;AAxCF;AA6CA;EArHE,aAAA;EACA,sBAAA;EACA,gBAAA;EAqHA,OAAA;AAzCF;AA4CA;EArHE,OAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AA4EF;AAyCA;EAlHE,YAAA;AA4EF;AA2CA;EApHE,YAAA;EACA,gBAAA;EACA,gBAAA;EAEA,yBAAA;EACA,0CAAA;EACA,6CAAA;EAgHA,gBAAA;AApCF;AAuCA;EAhHE,gBAAA;EAkHA,gBAAA;EACA,kBAAA;EACA,OAAA;AArCF;AAwCA;EACE,yBAAA;AAtCF;AAwCA;EACE,yBAAA;AAtCF;AAwCA;EACE,yBAAA;AAtCF;AAwCA;EACE,yBAAA;AAtCF;AAwCA;EACE,yBAAA;AAtCF;AAyCA;EACE,YAAA;EACA,iBAAA;AAvCF;AAyCA;EACE,aAAA;EACA,QAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,cAAA;EAEA,0BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAxCF;AA0CA;EACE,WAAA;EACA,YAAA;AAxCF;AA2CA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAzCF;AA2CA;EACE,gBAAA;EACA,gBAAA;EACA,OAAA;AAzCF","sourcesContent":["// +--mainBox---------------------------------------------------+\n// |+--leftPart-----------------+░+-rightPart------------------+|\n// ||+--leftTable--------------+|░|+--rightTable--------------+||\n// |||+--leftHead-------------+||░||+--rightHead-------------+|||\n// ||||                       |||░|||                        ||||\n// |||+-----------------------+||░||+------------------------+|||\n// |||+--leftBody-------------▲||░||+--rightHead-------------▲|||\n// ||||                       ║||░|||                        ║|||\n// ||||                       ║||░|||                        ║|||\n// ||||                       ║||░|||                        ║|||\n// |||+-----------------------▼||░||+------------------------▼|||\n// ||+<=======================>+|░|+<========================>+||\n// ||+--leftFoot---------------+|░|+--rightFoot---------------+||\n// |||                         ||░||                          |||\n// ||+-------------------------+|░|+--------------------------+||\n//\n// part = table + foot\n// table = head + body\n// левая и правая таблицы имеют одинаковую высоту, которая = mainHeight - footHeiht\n// правая часть горизонтально скроллируется целиком\n// левая часть имеет зафиксированные колонки, поэтому скролл только для нефиксированных колонок\n// фиксированные колонки выводятся по абсолютной позиции поверх остальных\n// это позволит сделать общий горизонтальный скролл для таблицы\n\n@headHeight: 48px; // <-- это значение должно совпадать с Planning2GanttStore.headHeight\n@cellHeight: 38px; // <-- это значение должно совпадать с Planning2GanttStore.cellHeight\n@footHeight: 32px;\n\n@borderColor: rgba(0, 0, 0, 0.06);\n@border: thin solid @borderColor;\n\n@colorPrognosis: #adc6ff;\n@colorFact: #1a8a94;\n@colorPlan: #83a3af;\n@colorDelay: #c20034;\n@colorWork: #e0a23c;\n\n.mainBox {\n  display: flex;\n  height: 100%;\n  overflow: hidden;\n  position: relative;\n}\n\n.loader {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(255, 255, 255, 0.75);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1;\n}\n\n.splitter {\n  background-color: #f0f0f0;\n  display: flex;\n  padding: 0 2px;\n  justify-content: center;\n  align-items: center;\n  cursor: col-resize;\n  .center {\n    background-color: #bfbfbf;\n    height: 56px;\n    width: 4px;\n    border-radius: 4px;\n  }\n}\n\n.part {\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n.table {\n  flex: 1;\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n.foot {\n  height: @footHeight;\n}\n.head {\n  height: @headHeight;\n  min-height: @headHeight;\n  max-height: @headHeight;\n  overflow: hidden;\n  background-color: #fafafa;\n  border-top: @border;\n  border-bottom: @border;\n}\n.body {\n  overflow: hidden;\n}\n.bodyBox {\n  flex: 1;\n  overflow-y: auto;\n  overflow-x: scroll;\n  position: relative;\n}\n\n// -------- left\n\n.leftPart {\n  .part();\n  min-width: 20%;\n  max-width: 90%;\n\n  &.singleLeftPart {\n    max-width: 100%;\n    .leftTable {\n      overflow-x: auto;\n    }\n  }\n}\n\n.leftTable {\n  .table();\n}\n\n.leftEmpty {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding-top: @headHeight;\n}\n\n.leftFoot {\n  .foot();\n}\n\n.leftHead {\n  .head();\n  display: grid;\n\n  .th {\n    border-right: @border;\n  }\n}\n\n.leftBody {\n  .body();\n  width: max-content;\n  display: grid;\n  grid-auto-rows: minmax(@cellHeight, @cellHeight);\n  overflow: visible; // чтобы у bodyBox появилась гориз. прокрутка\n\n  .td {\n    padding: 0 8px;\n    display: flex;\n    align-items: center;\n    border-bottom: @border;\n    border-right: thin solid transparent;\n\n    & > span {\n      overflow: hidden;\n      color: rgba(0, 0, 0, 0.85);\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      font-size: 14px;\n      font-weight: 400;\n      line-height: 160%;\n    }\n  }\n}\n\n.fixedCell {\n  position: sticky;\n  z-index: 1;\n  background-color: #fff;\n}\n.fixedOverlap {\n  box-shadow: 10px 0 8px -8px rgba(5, 5, 5, 0.1);\n}\n.fixedLastCell {\n  border-right: @border !important;\n}\n\n// ----------- right\n\n.rightPart {\n  .part();\n  flex: 1;\n}\n\n.rightTable {\n  .table();\n}\n\n.rightFoot {\n  // Тут располагается легенда и настройки Ганта\n  .foot();\n}\n\n.rightHead {\n  .head();\n  overflow: hidden;\n}\n\n.rightBody {\n  .body();\n  overflow-y: auto;\n  overflow-x: scroll;\n  flex: 1;\n}\n\n.prognosisBar {\n  background-color: @colorPrognosis;\n}\n.factBar {\n  background-color: @colorFact;\n}\n.planBar {\n  background-color: @colorPlan;\n}\n.delayBar {\n  background-color: @colorDelay;\n}\n.workBar {\n  background-color: @colorWork;\n}\n\n.ganttToolBox {\n  height: 100%;\n  overflow: visible;\n}\n.ganttTools {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  justify-content: flex-end;\n  height: 100%;\n  padding: 0 9px;\n\n  color: rgba(0, 0, 0, 0.55);\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 150%;\n}\n.legendBar {\n  width: 10px;\n  height: 10px;\n}\n\n.legendItem {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n.scaleBox {\n  min-width: 100px;\n  max-width: 100px;\n  flex: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainBox": `src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__mainBox--aETY4`,
	"loader": `src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__loader--LZHza`,
	"splitter": `src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__splitter--zC5y5`,
	"center": `src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__center--n0Pa7`,
	"part": `src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__part--rRVrr`,
	"table": `src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__table--DJP_d`,
	"foot": `src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__foot--ISbvP`,
	"head": `src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__head--aY5JQ`,
	"body": `src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__body--BChGj`,
	"bodyBox": `src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__bodyBox--nOuuF`,
	"leftPart": `src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__leftPart--zgatE`,
	"singleLeftPart": `src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__singleLeftPart--nxn6Q`,
	"leftTable": `src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__leftTable--SJSL9`,
	"leftEmpty": `src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__leftEmpty--VSQR9`,
	"leftFoot": `src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__leftFoot--yAupx`,
	"leftHead": `src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__leftHead--DBfEf`,
	"th": `src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__th--lifFD`,
	"leftBody": `src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__leftBody--JuF0I`,
	"td": `src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__td--WOgoS`,
	"fixedCell": `src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__fixedCell--rnRJk`,
	"fixedOverlap": `src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__fixedOverlap--BLfOo`,
	"fixedLastCell": `src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__fixedLastCell--b3yDe`,
	"rightPart": `src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__rightPart--YD3qP`,
	"rightTable": `src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__rightTable--dexv6`,
	"rightFoot": `src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__rightFoot--AlI_z`,
	"rightHead": `src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__rightHead--I4u1H`,
	"rightBody": `src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__rightBody--Y3rwx`,
	"prognosisBar": `src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__prognosisBar--xexNx`,
	"factBar": `src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__factBar--kR0wi`,
	"planBar": `src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__planBar--SVamG`,
	"delayBar": `src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__delayBar--GWu_G`,
	"workBar": `src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__workBar--y50CH`,
	"ganttToolBox": `src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__ganttToolBox--XM_Eu`,
	"ganttTools": `src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__ganttTools--lYDWm`,
	"legendBar": `src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__legendBar--AYLCG`,
	"legendItem": `src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__legendItem--X5kdY`,
	"scaleBox": `src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2Gantt-module__scaleBox--MXsfq`
};
export default ___CSS_LOADER_EXPORT___;
